var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16138 37.068V7.06795C4.16138 6.15129 4.48804 5.36684 5.14138 4.71462C5.79471 4.0624 6.57915 3.73573 7.49471 3.73462H34.1614C35.078 3.73462 35.863 4.06129 36.5164 4.71462C37.1697 5.36795 37.4958 6.1524 37.4947 7.06795V27.068C37.4947 27.9846 37.1686 28.7696 36.5164 29.423C35.8642 30.0763 35.0792 30.4024 34.1614 30.4013H10.828L4.16138 37.068ZM20.828 25.4013C21.3003 25.4013 21.6964 25.2413 22.0164 24.9213C22.3364 24.6013 22.4958 24.2057 22.4947 23.7346C22.4936 23.2635 22.3336 22.868 22.0147 22.548C21.6958 22.228 21.3003 22.068 20.828 22.068C20.3558 22.068 19.9603 22.228 19.6414 22.548C19.3225 22.868 19.1625 23.2635 19.1614 23.7346C19.1603 24.2057 19.3203 24.6018 19.6414 24.923C19.9625 25.2441 20.358 25.4035 20.828 25.4013ZM19.1614 18.7346H22.4947V8.73462H19.1614V18.7346Z",
    fill: "#FEC200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.c5e7991eae595a154befa4a885738345.svg";
export { ForwardRef as ReactComponent };